import * as React from "react";

function SvgFacebook(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...{ ...props, ref }}>
      <path
        d="M21.164 5.074c-1.984 0-2.548.88-2.548 2.82v3.202h5.277l-.52 5.187h-4.758V32H12.3V16.282H8.04v-5.187h4.262V7.983C12.302 2.75 14.4 0 20.285 0c1.263 0 2.774.1 3.676.226v4.87"
        fill="#3c5a99"
      />
    </svg>
  );
}

export default React.forwardRef(SvgFacebook);
